import { useQuery } from "@tanstack/react-query";
import { getImagesByMediaId } from "../services/images.service";
import { QueryKeys } from "./queryKeys";

export const useImagesByMediaId = (mediaId: string, groupId?: string) => {
  return useQuery({
    queryKey: [QueryKeys.ImagesByMedia, mediaId, groupId],
    queryFn: () => getImagesByMediaId(mediaId, groupId),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 15,
    enabled: !!mediaId,
  });
};
